import { useSelector } from "react-redux";
import { getFileTypeIcon } from "../../../../../utils/functions/file-icon-extractor";
import QuestionAndAnswerIcon from "../../../../../assets/svg/question-and-answer-icon";
import WebsiteIcon from "../../../../../assets/svg/website-icon";
import DocumentAddedIcon from "../../../../../assets/svg/document-added-icon";
import StarIcon from "../../../../../assets/svg/star-icon";
import { RootState } from "../../../../../redux/store";
import { getRegionLabel } from "../../../../../utils/constants/mappings";

const AddContentView = ({
  handleSelectContentType,
}: {
  handleSelectContentType: (contentType: string) => void;
}) => {
  const clientCode = useSelector(
    (state: RootState) => state?.auth?.client?.client_code
  );
  const knowledgeBaseLabel = getRegionLabel("knowledgeBaseSection", clientCode);
  const contentTypes = [
    {
      id: "doc",
      title: "Upload Document",
      description: (
        <>
          Upload your files and let VerbaFlo AI create fresh, insightful content{" "}
          <br /> instantly. Documents in <b>.doc, .pdf or .xlsx</b> formats are
          supported
        </>
      ),
      icon: (
        <DocumentAddedIcon className="w-10.5 h-10.5 text-verba-indigo dark:text-verba-indigo-dk" />
      ),
    },
    {
      id: "website",
      title: "Sync Content from any Website",
      description: (
        <>
          Extract and repurpose website content effortlessly with VerbaFlo’s{" "}
          <br /> smart AI scraper.
        </>
      ),
      icon: (
        <WebsiteIcon className="w-8.5 h-8.5 text-verba-indigo dark:text-verba-indigo-dk" />
      ),
    },
    {
      id: "faq",
      title: "Add Custom FAQs",
      description: "Add and manage your own FAQs directly within the platform.",
      icon: (
        <QuestionAndAnswerIcon className="w-8.5 h-8.5 text-verba-indigo dark:text-verba-indigo-dk" />
      ),
    },
  ];
  return (
    <>
      {" "}
      <h2 className="text-2xl font-medium text-verba-indigo dark:text-verba-indigo-dk">
        Add Content
      </h2>
      <p className="text-base text-verba-indigo dark:text-verba-indigo-dk">
        Quickly add content to your {knowledgeBaseLabel} by uploading files,
        scraping sites, or creating FAQs. All powered by <b>VerbaFlo AI</b>.
      </p>
      <div className="flex flex-col gap-3 mt-[38px]">
        {contentTypes.map((contentType) => (
          <div
            key={contentType.id}
            className="relative flex items-center gap-2 border border-border-gray dark:border-border-gray-dk hover:border-verba-blue dark:hover:border-verba-blue-dk hover:bg-verba-blue-light-card-bg hover:dark:bg-verba-blue-light-card-bg-dk rounded-lg px-4 py-8.5 cursor-pointer"
            onClick={() => handleSelectContentType(contentType.id)}
          >
            <div className="absolute top-0 right-0  border border-border-gray dark:border-border-gray-dk rounded-md flex items-center justify-center"></div>
            {contentType.icon}
            <div className="flex flex-col gap-1">
              <h3 className="text-base font-medium text-verba-indigo dark:text-verba-indigo-dk">
                {contentType.title}
              </h3>
              <p className="text-md text-dark-gray dark:text-dark-gray-dk">
                {contentType.description}
              </p>
              {contentType.id === "website" && (
                <div className="absolute top-[17px] right-1 flex items-center gap-1 border border-border-gray dark:border-border-gray-dk rounded-md p-1 w-[53px] shadow-sm">
                  <StarIcon className="w-4 h-4 text-rating-yellow dark:text-rating-yellow-dk" />
                  <span className="text-md font-medium text-verba-blue dark:text-verba-blue-dk">
                    New
                  </span>
                </div>
              )}
              <div className="flex items-center gap-2">
                {contentType.id === "doc" && (
                  <>
                    <img
                      src={getFileTypeIcon("Doc")}
                      alt={contentType.id}
                      className="w-4 h-4"
                    />
                    <img
                      src={getFileTypeIcon("PDF")}
                      alt={contentType.id}
                      className="w-4 h-4"
                    />
                    <img
                      src={getFileTypeIcon("xlsx")}
                      alt={contentType.id}
                      className="w-4 h-4"
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default AddContentView;
